import { UnauthorisedError } from "@/features/errors/unauthorized-error";

export const Route = createFileRoute({
  component: UnauthorisedError,
});
